import getAuthToken from './getAuthToken'
import getUser from './getUser'
import resetPassword from './resetPassword'
export const getAuthTokenPromise = getAuthToken
export const getUserPromise = getUser
export const resetPasswordPromise = resetPassword
